import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import authService from '../../services/authService';

const user = JSON.parse(localStorage.getItem('adminUser'));
const token = localStorage.getItem('adminToken');

const initialState = {
  user: user || null,
  token: token || null,
  isAuthenticated: !!(user && token),
  isLoading: false,
  error: null,
  otpSent: false,
  mobile: '',
};

export const sendOtp = createAsyncThunk(
  'auth/sendOtp',
  async (mobile, thunkAPI) => {
    try {
      const response = await authService.sendOtp(mobile);
      return { ...response, mobile };
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Failed to send OTP';
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const verifyOtp = createAsyncThunk(
  'auth/verifyOtp',
  async ({ mobile, otp }, thunkAPI) => {
    try {
      const response = await authService.verifyOtp(mobile, otp);
      return response;
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Failed to verify OTP';
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const logout = createAsyncThunk('auth/logout', async (_, thunkAPI) => {
  try {
    await authService.logout();
  } catch (error) {
    console.error('Logout error:', error);
  }
});

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    resetAuth: (state) => {
      state.error = null;
      state.otpSent = false;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Send OTP
      .addCase(sendOtp.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(sendOtp.fulfilled, (state, action) => {
        state.isLoading = false;
        state.otpSent = true;
        state.mobile = action.payload.mobile;
      })
      .addCase(sendOtp.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Verify OTP
      .addCase(verifyOtp.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isAuthenticated = true;
        state.user = action.payload.user;
        state.token = action.payload.token;
        state.otpSent = false;
        localStorage.setItem('adminUser', JSON.stringify(action.payload.user));
        localStorage.setItem('adminToken', action.payload.token);
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Logout
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
        state.token = null;
        state.isAuthenticated = false;
        state.otpSent = false;
        state.mobile = '';
        localStorage.removeItem('adminUser');
        localStorage.removeItem('adminToken');
      });
  },
});

export const { resetAuth, clearError } = authSlice.actions;
export default authSlice.reducer;
